// extracted by mini-css-extract-plugin
export default {"link":"bL-z","disabled":"cL-z"};